import { Sparkles, X } from 'lucide-react'
import { useThemeOrchestratorStore } from '@/stores/themeOrchestratorStore'

export function TimeCapsuleBanner() {
  const activeOverlay = useThemeOrchestratorStore((s) => s.activeOverlay)
  const timeCapsuleData = useThemeOrchestratorStore((s) => s.timeCapsuleData)
  const dismissTimeCapsule = useThemeOrchestratorStore((s) => s.dismissTimeCapsule)

  if (activeOverlay !== 'victory-gold' || !timeCapsuleData) return null

  return (
    <div className="mx-4 mt-4 p-4 rounded-2xl bg-accent-primary border border-strong animate-in fade-in slide-in-from-top-4">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-xl bg-surface-primary">
            <Sparkles className="w-5 h-5 text-accent-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-heading text-sm">1년 전 오늘의 기록</h3>
            <p className="text-sm text-body mt-1">
              {timeCapsuleData.historicalDate}에 <span className="font-medium text-accent-primary">{timeCapsuleData.completionCount}개</span>의 할 일을 완료했습니다!
            </p>
            <p className="text-xs text-caption mt-1">Victory Gold 테마가 오늘 하루 활성화됩니다.</p>
          </div>
        </div>
        <button
          type="button"
          onClick={dismissTimeCapsule}
          className="p-1 rounded-lg hover-surface text-caption flex-shrink-0"
          aria-label="배너 닫기"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
